import React, { useState, useMemo } from 'react';
import '../styles/PublicationsPage.css';

export default function PublicationsPage() {
  const [selectedYear, setSelectedYear] = useState('all');

  // Publications library data - update with actual PDF URLs
  const publications = [
    {
      id: 1,
      title: 'Acte de congrès GSIDA 2026',
      year: 2026,
      type: 'journal',
      category: 'Actes de congrès',
      description: 'Actes complets du congrès GSIDA 2026',
      pdfUrl: '/pdfs/acte-congres-gsida-2026.pdf',
    },
    {
      id: 2,
      title: 'Rapport GSIDA 2025',
      year: 2025,
      type: 'report',
      category: 'Rapports',
      description: 'Rapport complet des activités GSIDA 2025',
      pdfUrl: '/pdfs/rapport-gsida-2025.pdf',
    },
    {
      id: 3,
      title: 'Acte de congrès GSIDA 2025',
      year: 2025,
      type: 'journal',
      category: 'Actes de congrès',
      description: 'Actes complets du congrès GSIDA 2025',
      pdfUrl: '/pdfs/acte-congres-gsida-2025.pdf',
    },
    {
      id: 4,
      title: 'Rapport GSIDA 2024',
      year: 2024,
      type: 'report',
      category: 'Rapports',
      description: 'Rapport complet des activités GSIDA 2024',
      pdfUrl: '/pdfs/rapport-gsida-2024.pdf',
    },
    {
      id: 5,
      title: 'Acte de congrès GSIDA 2024',
      year: 2024,
      type: 'journal',
      category: 'Actes de congrès',
      description: 'Actes complets du congrès GSIDA 2024',
      pdfUrl: '/pdfs/acte-congres-gsida-2024.pdf',
    },
  ];

  // Get unique years for filter
  const years = ['all', ...new Set(publications.map(p => p.year))].sort((a, b) => {
    if (a === 'all') return -1;
    if (b === 'all') return 1;
    return b - a;
  });

  // Filter publications based on selected year
  const filteredPublications = useMemo(() => {
    if (selectedYear === 'all') {
      return publications.sort((a, b) => b.year - a.year);
    }
    return publications
      .filter(p => p.year === parseInt(selectedYear))
      .sort((a, b) => b.year - a.year);
  }, [selectedYear]);

  return (
    <div className="publications-page">
      <div className="publications-container">
        {/* Header */}
        <div className="publications-header">
          <h1>Publications</h1>
          <p>Accédez à l'ensemble de nos publications et rapports en format A4 PDF</p>
        </div>

        {/* Filter Section */}
        <div className="publications-filter">
          <div className="filter-group">
            <label htmlFor="year-filter">Filtrer par année:</label>
            <select
              id="year-filter"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="filter-select"
            >
              {years.map(year => (
                <option key={year} value={year}>
                  {year === 'all' ? 'Toutes les années' : year}
                </option>
              ))}
            </select>
          </div>
          <div className="publications-count">
            {filteredPublications.length} publication{filteredPublications.length !== 1 ? 's' : ''}
          </div>
        </div>

        {/* Publications Library Grid */}
        <div className="publications-library">
          {filteredPublications.length > 0 ? (
            filteredPublications.map(pub => (
              <div key={pub.id} className="publication-card">
                <div className="publication-card-header">
                  <span className="publication-year">{pub.year}</span>
                  <span className="publication-category">{pub.category}</span>
                </div>
                <div className="publication-card-content">
                  <h3>{pub.title}</h3>
                  <p>{pub.description}</p>
                </div>
                <div className="publication-card-footer">
                  <a
                    href={pub.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="publication-download-btn"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Ouvrir PDF
                  </a>
                </div>
              </div>
            ))
          ) : (
            <div className="no-publications">
              <p>Aucune publication disponible pour cette année.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
